module.exports = __webpack_public_path__ + "img/householdequipment3.0d5b8093.png";